import { type FC, type FormEvent, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@lib/components'
import { useLocalStorage } from '@lib/hooks'
import cookiebg from '~/assets/Cookies BG.png'

export const CookiePreferences: FC = () => {
  const [hasAccepted, setHasAccepted] = useLocalStorage<boolean | null>('cookie-banner', null)
  const [preference, setPreference] = useState(hasAccepted)
  const [updating, setUpdating] = useState(false)

  const onSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault()
    setUpdating(true)
    setHasAccepted(preference)
    window.location.reload()
  }

  return <main>
    <div className="flex flex-col md:flex-row justify-center items-center">
      <div className="md:grid md:grid-cols-2 md:h-mtd-height-70">
        <div className="p-8 md:p-28 bg-cover bg-no-repeat text-mtd-black" style={{ backgroundImage: `url(${cookiebg})` }}>
          <h2 className="text-mtd-h2 font-bold mb-4">Cookie Preferences</h2>
          <p className="text-mtd-input font-normal mb-4">
            For more information on how we use cookies to improve your experience on our site please read our{' '}
            <Link className="underline text-mtd-blue" to="/privacy-policy">
              Privacy Policy
            </Link>.
          </p>
          <p className="text-mtd-body font-normal">
            If you would like to opt out of all cookies please adjust the settings within your browser. For instructions check your browser's technical
            information. By disabling all cookies you will not be able to use essential features of our site such as logging in to your account.
          </p>
        </div>

        <div className="bg-white p-8 md:p-28 flex flex-col justify-center text-mtd-secondary">
          <form onSubmit={onSubmit}>
            <label className="flex items-center mt-4 cursor-pointer text-mtd-label">
              <input
                className="mr-2"
                type="radio"
                name="preference"
                onChange={() => setPreference(true)}
                checked={preference ?? false}
              />
              Allow all cookies
            </label>
            <label className="flex items-center mt-1 cursor-pointer text-mtd-label">
              <input
                className="mr-2"
                type="radio"
                name="preference"
                onChange={() => setPreference(false)}
                checked={!(preference ?? false)}
              />
              Allow strictly necessary cookies only
            </label>
            <Button
              variant="mtd-primary"
              className="mt-8 w-80 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full py-2 text-white font-semibold"
              type="submit"
              loading={updating}
              disabled={updating}
            >
              Update
            </Button>
          </form>
        </div>
      </div>
    </div>
  </main>
}
